import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';
import { SnackbarState, SnackbarStateItem } from './types';

const initialSnackbarState: SnackbarState = {
  snackbars: [],
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState: initialSnackbarState,
  reducers: {
    addSnackbar(state, action: PayloadAction<Omit<SnackbarStateItem, 'id'>>) {
      const newSnackbars = state.snackbars.filter((snackbar) => snackbar.message !== action.payload.message);
      newSnackbars.push({ ...action.payload, id: _.uniqueId() });
      state.snackbars = newSnackbars;
    },
    removeSnackbar(state, action: PayloadAction<string | number>) {
      state.snackbars = state.snackbars.filter((snackbar) => snackbar.id !== action.payload);
    },
  },
});

export const { addSnackbar, removeSnackbar } = snackbarSlice.actions;
export const snackbarReducer = snackbarSlice.reducer;
